import * as React from 'react';
import { Route } from 'react-router';
import RegistrationView from './modules/registration/RegistrationView';
import BpiView from './modules/bpi/BpiView';
import CollectView from './modules/collect/CollectView';
import TagManager from 'react-gtm-module';
import './custom.css'


type Props = {
}

interface State {
    view: string;
}

const tagManagerArgs = {
    gtmId: 'GTM-PSLJRM'
}

TagManager.initialize(tagManagerArgs)

class App extends React.Component<Props, State> {

    // --------------------------------------------------------------------------------------------
    // render

    public render() {
        return (
            <div className="main-container">
                <Route exact path='/' component={RegistrationView} />
                <Route exact path='/register' component={RegistrationView} />
                <Route path='/bpi' component={BpiView} />
                <Route path='/collect/:code' component={CollectView} exact/>
            </div>
        );
    }
};


export default App;
